import React from 'react';
import {
  hasDismissedAlert,
  AlertRulesEngineOptions,
} from 'src/helpers/alerts/index';
import { Rule } from 'src/helpers/rulesEngine';
import Alert from 'src/components/Alert/';
import { isActive } from 'src/helpers/page';

const DocumentVerificationPendingAlert: Rule<
  JSX.Element,
  AlertRulesEngineOptions
> = (state, options) => {
  const { verificationStatus, status } = state.page;
  const alertKey = 'verify_identity_pending';

  if (
    isActive({ status }) &&
    verificationStatus === 'DocumentVerificationPending' &&
    !hasDismissedAlert(state.page.id, alertKey)
  ) {
    return {
      matched: true,
      result: (
        <Alert
          id={alertKey}
          type="amber"
          onClose={options!.onClose}
          page={state.page}
        >
          <p className="jg-space-mbn">
            Thanks for uploading your document. Weʼll let you know the result
            within two business days.
          </p>
        </Alert>
      ),
    };
  }

  return { matched: false };
};

export default DocumentVerificationPendingAlert;



// WEBPACK FOOTER //
// ./src/helpers/alerts/DocumentVerificationPendingAlert.tsx